import React, { PureComponent } from 'react'
import { string, object } from 'prop-types'
import { Text } from 'components'
import ITEM from 'utils/constants/items'
import { find, sum } from 'lodash'
import { translate } from 'react-i18next'
import { getCurrentPriceUnit, getTotalPrice } from 'utils/prices'

@translate()
export class PanelAMToolKPIs extends PureComponent {
    static propTypes = {
        data: object.isRequired,
        selectedGroupId: string,
        selection: object.isRequired,
    }
    static defaultProps = {
    }


    renderKPI = (value, percentage, text) => (
        <div className="PanelAMToolKPI flex row-center pl-20p">
            <div className="PanelAMToolKPI-Value">
                <svg viewBox="0 0 100 100">
                    <circle cx={50} cy={50} r={42.5} strokeWidth={15} />
                    <circle
                        ref={this.setCircleRef}
                        cx={50}
                        cy={50}
                        r={42.5}
                        strokeWidth={15}
                        strokeDasharray={2 * Math.PI * 42.5}
                        strokeDashoffset={2 * Math.PI * 42.5 * (1 - (percentage / 100))}
                    />
                </svg>
                <Text>{value}</Text>
            </div>
            <ul className="PanelAMToolKPI-Bullet flex-grow">
                <Text tag="li">{text}</Text>
            </ul>
        </div>
    )

    render() {
        const { data, selectedGroupId, selection, className, t } = this.props
        if (data && data[ITEM.PRE_SEASON_PERF_TOT_EX] && selectedGroupId) {
            const kpi1 = kpi1Calculation(data, selectedGroupId, selection)
            const kpi2 = kpi2Calculation(data, selectedGroupId, selection)
            return (
                <div className={['PanelAMToolKPIs flex-self-center p-20p', className]}>
                    {this.renderKPI(kpi1.toFixed(2), kpi1AsPercentage(kpi1), t('game.PRE_SEASON.kpiIndividualContribution', { name: 'engine ' }))}
                    {this.renderKPI(kpi2.toFixed(2), kpi2AsPercentage(kpi2), t('game.PRE_SEASON.kpiCombinedContribution'))}
                </div>
            )
        }
        return null
    }
}

function kpi1Calculation(data, selectedGroupId, selection) {
    const selectedGroup = data[selectedGroupId]
    const selectedType = (selection[selectedGroupId] || {}).type || selectedGroup.options[0].id
    const selectedOption = find(selectedGroup.options, o => o.id === selectedType)
    return selectedOption.mcr
}
function kpi1AsPercentage(kpi1) {
    // as excels show the range goes from 1.93 to 18.21. So we take the range from 0 to 19
    return asPercentage(kpi1, 0, 19)
}
function kpi2Calculation(data, selectedGroupId, selection) {
    const { dTot, tps } = data[ITEM.PRE_SEASON_PERF_TOT_EX]
    const perItem = [
        getItemDataValues(data, ITEM.PRE_SEASON_ENGINE, selection),
        getItemDataValues(data, ITEM.PRE_SEASON_GEARBOX, selection),
        getItemDataValues(data, ITEM.PRE_SEASON_WHEELS, selection)
    ]
    const wheelsAssetLife = perItem[2].assetLife
    const a = 1 / (2 * sum(perItem.map(({ pAvg, weight, pmax }) => pAvg * weight * pmax)))
    const b = (tps / 60) / wheelsAssetLife
    const c = dTot * sum(perItem.map(({ maintFactor, price, assetLife }) => (maintFactor * price) / assetLife))
    return 1 / ((a + b) * c)
}
function getItemDataValues(data, groupId, selection) {
    const selectedGroup = data[groupId]
    const selectedType = (selection[groupId] || {}).type || selectedGroup.options[0].id
    const selectedOption = find(selectedGroup.options, o => o.id === selectedType)
    return {
        groupId,
        pAvg: selectedGroup.perfTotEx.pAvg,
        weight: selectedGroup.perfTotEx.weight,
        maintFactor: selectedGroup.perfTotEx.maintFactor,
        pmax: selectedOption.performanceMax,
        assetLife: selectedOption.expectedAssetLife,
        price: selectedOption.prices[0],
    }
}
function kpi2AsPercentage(kpi2) {
    // as excels show the range goes from 1.68 to 2.05. So we take the range from 1.5 to 2.10
    return asPercentage(kpi2, 1.5, 2.10)
}
function asPercentage(v, min, max) {
    return Math.min(Math.max(((v - min) / (max - min)) * 100, 0), 100)
}



// WEBPACK FOOTER //
// src/components/Panel/PanelAMToolKPIs.js